import actions from './actions'
import { factoryReducer } from '../factory'

// Defining the Initial Variables to be saved in the Redux Store on initialize.
const initialState = {
  subscriptionList: [],
  loading: false,
  modalVisibleAdd: false,
  AddNumberModalLoading: false,
  devices: [],
  subscriptionListDisabled: [],
}

export default factoryReducer(initialState, actions)
